import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VerifyDate } from 'src/app/shared/custom-validators/date.validator';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';

@Component({
  selector: 'app-birth-date-confirm-patient-modal',
  templateUrl: './birth-date-confirm-patient-modal.component.html',
  styleUrls: ['./birth-date-confirm-patient-modal.component.css']
})
export class BirthDateConfirmPatientModalComponent implements OnInit {
  constructor(private formBuilder: FormBuilder, private maskService: MaskService,
    private alertService: AlertService,
    private dialogRef: MatDialogRef<BirthDateConfirmPatientModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  model!: FormGroup;
  masks: Masks = this.maskService.getMasks();
  birthDate: string = '';
  ngOnInit(): void {
    this.birthDate = this.formatDate(this.data.birthDate)
    this.model = this.formBuilder.group({
      birthDate: ['', [Validators.required, VerifyDate()]]
    });
  }

  submit() {
    if (this.model.invalid) {
      this.alertService.show('Erro', 'Data de nascimento inválida.', AlertType.error);
      return;
    }

    if (!this.model.get('birthDate')?.value)
      return;

    if (this.model.get('birthDate')?.value !== this.birthDate)
      return this.alertService.show('Erro', 'Data de nascimento incorreta.', AlertType.error);

    this.dialogRef.close(this.model.get('birthDate')?.value);
  }

  private formatDate(date) {
    const birthDate = new Date(date);
    const birthDateYear = birthDate.getFullYear().toString();
    const birthDateMonth = (birthDate.getMonth() + 1).toString().padStart(2, '0');
    const birthDateDay = birthDate.getDate().toString().padStart(2, '0');
    return birthDateDay + birthDateMonth + birthDateYear;
  }
}